<template lang="pug">
  section.spinner-container.flex.content-center.justify-center.flex-wrap
    .spinner(:class="cls")
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        size: {
            type: Number,
            default: 24 // possible values: https://tailwindcss.com/docs/width/#fixed-width
        },
        thickness: {
            type: Number,
            default: 4 // possible values: 1 - 8
        }
    },
    computed: {
        cls() {
            let cls = ['ease-linear', 'rounded-full', 'border-gray-200'];

            let width = this.thickness;
            if (this.thickness < 1) width = 1;
            else if (this.thickness > 8) width = 8;

            cls.push(`border-${width}`);
            cls.push(`border-t-${width}`);

            let size = this.size;
            cls.push(`h-${size}`);
            cls.push(`w-${size}`);

            return cls;
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "@/assets/sass/_variables.sass"

.spinner-container
  min-height: 100%
  flex-grow: 1

.spinner
  border-color: theme("colors.gray.400")
  border-top-color: var(--color-primary)
  animation: spinner 1.5s linear infinite

@keyframes spinner
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
